export const API_URL = "https://hello.plithos-fund.workers.dev";
export const API_WS_URL = "wss://hello.plithos-fund.workers.dev";
export const BTCPAY_URL = "https://btcpay.plithos.fund";
